import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Image,
  Card,
  Form,
  Accordion,
  Nav,
  Tabs,
  Tab
} from "react-bootstrap";
import InfoToolTip from "../../components/InfoToolTip"
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PercentIcon from "@mui/icons-material/Percent";
import LocalAtm from "@mui/icons-material/LocalAtm";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PhoneInput, { getCountryCallingCode } from "react-phone-number-input";
import "../../css/views/secondary.scss";
import "../../css/views/student-portal.scss";
import "../../css/views/offers.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faCheck,
  faMagnifyingGlass,
  faArrowDown,
  faArrowUp,
  faChevronUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { Modal } from "antd";
import { usePostHog } from "posthog-js/react";
import { apiBaseUrl } from "../../lib/config";
import advisorImage from "../../assets/professional-advisor.png";
import celebrationImage from "../../assets/celebration.png";
import thanksIcon from "../../assets/thanks-icon.png";
import zolveCards from '../../assets/zolve-cards.png';
import creditBackground from '../../assets/credit-background.png';
import npSsn from '../../assets/no-ssn.png';
import buildCredit from '../../assets/build-credit.png';
import handMoney from '../../assets/hand-money.png';
import indianGraduate from '../../assets/indian-graduate.png';
import clock from '../../assets/clock.png';
import noFee from '../../assets/no-fee.png';
import percentage from '../../assets/percentage.png';
import USCreditCards from "../../components/USCreditCards";

const OfferSkeleton = () => {
  return (
    <Card className="offer-card mb-3">
      <Card.Body className="offer-card-body">
        <div className="offer-card-body-container">
          <div className="offer-info-container">
            <div className="bank-logo-container">
              <div
                className="skeleton-logo"
                style={{
                  height: "60px",
                  width: "120px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
            </div>
            <div className="offer-info">
              <div
                className="skeleton-text"
                style={{
                  height: "20px",
                  width: "100px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
              <div
                className="skeleton-text"
                style={{
                  height: "24px",
                  width: "80px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
            </div>
            <div className="offer-info">
              <div
                className="skeleton-text"
                style={{
                  height: "20px",
                  width: "100px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
              <div
                className="skeleton-text"
                style={{
                  height: "24px",
                  width: "80px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
            </div>
            <div className="offer-info">
              <div
                className="skeleton-text"
                style={{
                  height: "20px",
                  width: "100px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
              <div
                className="skeleton-text"
                style={{
                  height: "24px",
                  width: "80px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite ease-in-out",
                }}
              />
            </div>
          </div>
          <div className="offer-description">
            <div
              className="skeleton-text"
              style={{
                height: "16px",
                width: "100%",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "8px",
                animation: "pulse 1.5s infinite ease-in-out",
              }}
            />
            <div
              className="skeleton-text"
              style={{
                height: "16px",
                width: "90%",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "8px",
                animation: "pulse 1.5s infinite ease-in-out",
              }}
            />
            <div
              className="skeleton-text"
              style={{
                height: "16px",
                width: "80%",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                animation: "pulse 1.5s infinite ease-in-out",
              }}
            />
          </div>
        </div>
        <div className="select-btn-container">
          <div
            className="skeleton-button"
            style={{
              height: "40px",
              width: "100px",
              backgroundColor: "#e0e0e0",
              borderRadius: "4px",
              animation: "pulse 1.5s infinite ease-in-out",
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

const LoanOfferCard = ({ offer, handleSelectOffer, index }) => {
  const [expandedOffer, setExpandedOffer] = useState(false);
  return (
    <Card
      key={offer.uuid}
      className={`offer-card mb-3 ${expandedOffer ? "expanded" : ""}`}
    >
      {/* Mobile View */}
      <Card.Body className="mob-offer-card-body">
        <div className="offer-card-body-container">
          <div className="offer-info-container">
            <div className="bank-logo-container">
              <Image
                style={{ height: "60px" }}
                src={offer.logo_img_url}
                alt={offer.company_name}
                className="bank-logo"
              />
            </div>
            <div className="offer-info">
              <div className="offer-info-title">
                <Box display="flex" gap={0.5}>
                  <PercentIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                  <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Rate Of Interest</Typography>
                </Box>
              </div>
              <div className="offer-info-value">
                {offer.rate_of_interest ? (
                  <>
                    <span dangerouslySetInnerHTML={{ __html: offer.rate_of_interest }} />
                    {offer.interest_rate_info && (
                      <InfoToolTip textToDisplay={offer.interest_rate_info} />
                    )}
                  </>
                ) : offer.variable_rates || offer.fixed_rates ? (
                  <div>
                    {offer.variable_rates && (
                      <>
                        <strong>Variable Rates:</strong>
                        <span dangerouslySetInnerHTML={{ __html: offer.variable_rates }} />
                      </>
                    )}
                    {offer.fixed_rates && (
                      <>
                        <strong>Fixed Rates:</strong>
                        <span dangerouslySetInnerHTML={{ __html: offer.fixed_rates }} />
                      </>
                    )}
                    {offer.interest_rate_info && (
                      <InfoToolTip textToDisplay={offer.interest_rate_info} />
                    )}
                  </div>
                ) : (
                  "N/A"
                )}
              </div>
            </div>
            <div className="offer-info">
              <div className="offer-info-title">
                <Box display="flex" gap={0.5}>
                  <AccountBalanceWalletOutlinedIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                  <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Max Loan Amount</Typography>
                </Box>
              </div>
              <div className="offer-info-value">
                {offer.amounts_available || "N/A"}
                {offer.loan_amount_info && (
                  <InfoToolTip textToDisplay={offer.loan_amount_info} />
                )}
              </div>
            </div>
            <div className="offer-info">
              <div className="offer-info-title">
                <Box display="flex" gap={0.5}>
                  <AccessTimeIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                  <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Tenure</Typography>
                </Box>
              </div>
              <div className="offer-info-value">{offer.tenure || "N/A"}</div>
            </div>
            <div className="offer-info">
              <div className="offer-info-title">
                <Box display="flex" gap={0.5}>
                  <LocalAtm sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                  <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Loan Type</Typography>
                </Box>
              </div>
              <div className="offer-info-value">{offer.loan_type || "N/A"}</div>
            </div>
          </div>
          <div className="offer-description-container">
            {expandedOffer && (
              <>
                <div
                  className="offer-description"
                  dangerouslySetInnerHTML={{ __html: offer.description }}
                />
              </>
            )}
            {expandedOffer ? (
              <div
                onClick={() => {
                  setExpandedOffer(false);
                }}
                className="view-less-btn"
              >
                View Less <FontAwesomeIcon icon={faChevronUp} />
              </div>
            ) : (
              <div
                onClick={() => {
                  setExpandedOffer(true);
                }}
                className="view-more-btn"
              >
                View More <FontAwesomeIcon icon={faChevronDown} />
              </div>
            )}
          </div>
        </div>
        <div className="select-btn-container">
          {offer.url.toLowerCase().includes("app?mydocs=true") ? (
            <Button
              onClick={() => handleSelectOffer(offer.url, index, offer)}
              className="select-btn"
            >
              Get Started
            </Button>
          ) : (
            <Button
              onClick={() => handleSelectOffer(offer.url, index, offer)}
              className="select-btn"
            >
              Apply Now<NorthEastIcon sx={{ fontSize: 20 }} />
            </Button>
          )}
        </div>
      </Card.Body>

      {/* Desktop View */}
      <Card.Body className="offer-card-body">
        <div className="offer-card-details">
          <div className="offer-card-body-container">
            <div className="offer-info-container">
              <div className="bank-logo-container">
                <Image
                  style={{ height: "60px" }}
                  src={offer.logo_img_url}
                  alt={offer.company_name}
                  className="bank-logo"
                />
              </div>
              <div className="offer-info">
                <div className="offer-info-title">
                  <Box display="flex" gap={1}>
                    <PercentIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Rate Of Interest</Typography>
                  </Box>
                </div>
                <div className="offer-info-value">
                  {offer.rate_of_interest ? (
                    <>
                      <span dangerouslySetInnerHTML={{ __html: offer.rate_of_interest }} />
                      {offer.interest_rate_info && (
                        <InfoToolTip textToDisplay={offer.interest_rate_info} />
                      )}
                    </>
                  ) : offer.variable_rates || offer.fixed_rates ? (
                    <div>
                      {offer.variable_rates && (
                        <>
                          <strong>Variable Rates:</strong>
                          <span dangerouslySetInnerHTML={{ __html: offer.variable_rates }} />
                        </>
                      )}
                      {offer.fixed_rates && (
                        <>
                          <strong>Fixed Rates:</strong>
                          <span dangerouslySetInnerHTML={{ __html: offer.fixed_rates }} />
                        </>
                      )}
                      {offer.interest_rate_info && (
                        <InfoToolTip textToDisplay={offer.interest_rate_info} />
                      )}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </div>
              </div>
              <div className="offer-info">
                <div className="offer-info-title">
                  <Box display="flex" gap={1}>
                    <AccountBalanceWalletOutlinedIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Max Loan Amount</Typography>
                  </Box>
                </div>
                <div className="offer-info-value">
                  <>
                    {offer.amounts_available || "N/A"}
                    {offer.loan_amount_info && (
                      <InfoToolTip textToDisplay={offer.loan_amount_info} />
                    )}
                  </>
                </div>
              </div>
              <div className="offer-info">
                <div className="offer-info-title">
                  <Box display="flex" gap={1}>
                    <AccessTimeIcon sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Tenure</Typography>
                  </Box>
                </div>
                <div className="offer-info-value">{offer.tenure || "N/A"}</div>
              </div>
              <div className="offer-info">
                <div className="offer-info-title">
                  <Box display="flex" gap={1}>
                    <LocalAtm sx={{ color: "#0076CE", backgroundColor: "#E6F4FF", borderRadius: "50%", padding: "4px" }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontFamily: '"Poppins", "Arvo", Tahoma', color: "#344054" }}>Loan Type</Typography>
                  </Box>
                </div>
                <div className="offer-info-value">{offer.loan_type || "N/A"}</div>
              </div>
            </div>
          </div>
          <div className="select-btn-container">
            {offer.url.toLowerCase().includes("app?mydocs=true") ? (
              <Button
                onClick={() => handleSelectOffer(offer.url, index, offer)}
                className="select-btn"
              >
                Get Started
              </Button>
            ) : (
              <Button
                onClick={() => handleSelectOffer(offer.url, index, offer)}
                className="select-btn"
              >
                Apply Now<NorthEastIcon sx={{ fontSize: 20 }} />
              </Button>
            )}
          </div>
        </div>
        <div className="offer-description-container">
          {expandedOffer && (
            <>
              <div
                className="offer-description"
                dangerouslySetInnerHTML={{ __html: offer.description }}
              />
              {offer.long_disclosure ? (
                <Accordion style={{ marginTop: "50px" }}>
                  <Accordion.Item eventKey="0" className="unstyled-accordion">
                    <Accordion.Header style={{ margin: "1rem", padding: "1rem" }}>
                      <span>
                        {offer.more_info_text
                          ? offer.more_info_text
                          : "Disclosure"}
                        <FontAwesomeIcon icon={faChevronDown} />
                      </span>
                    </Accordion.Header>
                    <Accordion.Body style={{ margin: "1rem", padding: "1rem" }}>
                      {offer.long_disclosure ? (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: offer.long_disclosure,
                          }}
                        ></p>
                      ) : (
                        ""
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              ) : (
                ""
              )}
            </>
          )}
          {expandedOffer ? (
            <div
              onClick={() => {
                setExpandedOffer(false);
              }}
              className="view-less-btn"
            >
              View Less <FontAwesomeIcon icon={faChevronUp} />
            </div>
          ) : (
            <div
              onClick={() => {
                setExpandedOffer(true);
              }}
              className="view-more-btn"
            >
              View More <FontAwesomeIcon icon={faChevronDown} />
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
const Offers = (props) => {
  const [offerData, setOfferData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [likelyOffers, setLikelyOffers] = useState(null);
  const [likelyOfferTab, setLikelyOfferTab] = useState(null);
  const [userData, setUserData] = useState({});
  const [advertisingDisclosuresVisible, setAdvertisingDisclosuresVisible] =
    useState(false);
  const [applicationType, setApplicationType] = useState(null);
  const [thisApplication, setThisApplication] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const user_id = urlParams.get("user_id");
  const searchParams = new URLSearchParams(window.location.search);
  const fromPopup = searchParams.get("fromPopup");
  const posthog = usePostHog();

  let humanize = (str) => {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };

  const PhoneField = (props) => {
    let defaultValue = props.defaultValue;
    if (!defaultValue) defaultValue = null;
    const [value, setValue] = useState(defaultValue);
    let name = props.name;
    if (!name) name = "phone_number";
    return (
      <PhoneInput
        className="phone-field"
        name={name}
        defaultCountry="IN"
        value={value}
        required
        onChange={setValue}
      />
    );
  };

  function sessionStorageHasUtms() {
    return (
      sessionStorage.getItem("utm_source") !== null ||
      sessionStorage.getItem("utm_medium") !== null ||
      sessionStorage.getItem("utm_campaign") !== null ||
      sessionStorage.getItem("utm_term") !== null ||
      sessionStorage.getItem("utm_content") !== null
    );
  }

  useEffect(() => {
    let ecData = localStorage.getItem("ecData");
    if (ecData) {
      ecData = JSON.parse(ecData);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "ec_form_submit",
        ecData: ecData
      });
      localStorage.removeItem("ecData");
    }

    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      setIsLoading(true);
      fetch(`${apiBaseUrl}/api/v2/newsite/get_user_details_wordpress`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else if (response?.status === 401) {
            localStorage.removeItem("accessToken");
            window.location.href = "/sign-in?sign_in=true";
            throw new Error(response.statusText);
          } else {
            throw new Error(response.statusText);
          }
        })
        .then((response) => {
          setUserData(response);
          let utmParams = {
            utm_source: sessionStorage.getItem("utm_source"),
            utm_medium: sessionStorage.getItem("utm_medium"),
            utm_campaign: sessionStorage.getItem("utm_campaign"),
            utm_term: sessionStorage.getItem("utm_term"),
            utm_content: sessionStorage.getItem("utm_content"),
            path: sessionStorage.getItem("path_for_utm"),
          };
          const formBody = Object.keys(utmParams)
            .map(
              (key) =>
                encodeURIComponent(key) +
                "=" +
                encodeURIComponent(utmParams[key])
            )
            .join("&");

          if (sessionStorageHasUtms()) {
            fetch(
              `/nomadapi.php?order_id=/api/v1/utms&user_id=${user_id}&${formBody}`,
              {
                credentials: "include",
                method: "POST",
                body: JSON.stringify({
                  utm_source: sessionStorage.getItem("utm_source"),
                  utm_medium: sessionStorage.getItem("utm_medium"),
                  utm_campaign: sessionStorage.getItem("utm_campaign"),
                  utm_term: sessionStorage.getItem("utm_term"),
                  utm_content: sessionStorage.getItem("utm_content"),
                  path: sessionStorage.getItem("path_for_utm"),
                }),
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }
            )
              .then((response) => console.log(response.json()))
              .catch((error) => console.log(error));
            sessionStorage.removeItem("utm_source");
            sessionStorage.removeItem("utm_medium");
            sessionStorage.removeItem("utm_campaign");
            sessionStorage.removeItem("utm_term");
            sessionStorage.removeItem("utm_content");
            sessionStorage.removeItem("path_for_utm");
          }

          fetch(`${apiBaseUrl}/api/v2/newsite/application/${id}/offers`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(response.statusText);
              }
            })
            .then((response) => {
              posthog?.capture(
                `${fromPopup ? "Popup" : "Main"}  Signup - Offers`,
                { offers: response?.length || 0 }
              );

              if (Array.isArray(response)) {
                response.sort((a, b) => {
                  const aPriority = typeof a?.offer?.priority === 'number' ? a.offer.priority : Infinity;
                  const bPriority = typeof b?.offer?.priority === 'number' ? b.offer.priority : Infinity;
                  return aPriority - bPriority;
                });
              } else {
                console.warn("offers is not a valid array");
              }

              setOfferData(response);
            })
            .catch((error) => {
              console.error("error with offers", "" + error);
            })
            .finally(() => {
              setIsLoading(false);
            });
          fetch(`${apiBaseUrl}/api/v2/newsite/application/${id}/details`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(response.statusText);
              }
            })
            .then((response) => {
              setThisApplication(response);
              setApplicationType(response.application_type);
            })
            .catch((error) => {
              console.log("error", "" + error);
            });
          fetch(`${apiBaseUrl}/api/v2/newsite/likely_offers`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(response.statusText);
              }
            })
            .then((response) => {
              setLikelyOffers(response);

              if (response) {
                setLikelyOfferTab(Object.keys(response)[0]);
              }
            })
            .catch((error) => {
              console.log("error with offers", "" + error);
            });
        })
        .catch((error) => {
          console.log("error", "" + error);
          window.location.href = "/sign-in?sign_in=true";
        });
    } else {
      window.location.href = "/sign-in?sign_in=true";
    }
  }, []);

  useEffect(() => { }, []);

  const checkWaiver = async (details) => {
    fetch(
      `/nomadapi.php?order_id=/api/v1/applications/${id}/edit/admissions/waiver&user_id=${user_id}`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("waiver", response);
        response = response.data;
        window.location.href =
          "/dashboard" +
          `?dashboard=true&waiver_checked_path=${response.waiver_checked_path}&intake_path=${response.intake_path}&program_path=${response.program_path}&home_country_path=${response.home_country_path}&school_country_path=${response.school_country_path}`;
      })
      .catch((error) => {
        console.log("error", "" + error);
      });
  };

  const isWaiverChecked = () => {
    if (
      thisApplication &&
      thisApplication.data &&
      thisApplication.data.waiver_checked
    ) {
      return true;
    } else {
      return false;
    }
  };

  const selectOffer = (url, i, offer, likely = false) => {
    if (applicationType === "admissions") {
      if (isWaiverChecked()) {
        console.log("admissions", offer);
        window.location.href = "/dashboard?dashboard=true";
      } else {
        document.getElementById("offer_" + i).classList.add("hidden");
        document.getElementById("waiver_" + i).classList.remove("hidden");
      }
    } else {
      fetch(
        `/offerClick.php?application_offer_id=${offer.id}&offer_id=${offer.offer_id}&likely=${likely}&application_id=${id}&user_id=${user_id}`
      )
        .then((response) => response.json())
        .then((response) => {
          response = response.data;
          // if (response) {
          //   if (response.redirect_to)
          //     setShowToast(true);
          //   window.open(response.redirect_to, "_blank");
          // }

          if (response && response.redirect_to) {
            const url = response.redirect_to;
            if (url.includes("app?mydocs=true")) {
              const hostname = window.location.hostname;
              const isProd = /^(\w+\.)?nomadcredit\.com$/.test(hostname) && !hostname.startsWith("staging");
              const dashboardURL = `https://${isProd ? "student" : "staging-student"}.nomadcredit.com/documents`;          
              setShowToast(true);
              window.open(dashboardURL, "_blank");
            } else {
              setShowToast(true);
              window.open(url, "_blank");
            }
          }
        });
    }
  };

  const showAdvertisingDisclosures = () => {
    setAdvertisingDisclosuresVisible(true);
  };

  const handleSelectOffer = (url, index, offer) => {
    setSelectedOffer(offer);
    selectOffer(url, index, offer);
  };

  // if (selectedOffer) {
  //   return (
  //     <div className="thank-you-container">
  //       <Image
  //         src={celebrationImage}
  //         alt="Celebration"
  //         className="celebration-image"
  //       />
  //       <div className="thank-you-view ">
  //         <Image
  //           src={thanksIcon}
  //           style={{ width: "80px", height: "80px" }}
  //           alt="Thanks"
  //           className="thanks-icon"
  //         />
  //         <div>
  //           <h2>
  //             Thank you, <span>{userData?.first_name}</span> for choosing this
  //             offer!
  //           </h2>
  //           <p>Our team member will get you in touch shortly.</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  console.log('thisApplication', thisApplication)

  const isUSSchool =
    thisApplication?.data?.school_country === 'USA' ||
    thisApplication?.data?.school_country === 'United States';

  const defaultTab = isUSSchool ? 'credit' : 'refinance';

  const handleApplyClick = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts[0] === 'www') parts.shift();
    const isSubdomain = parts.length > 2;
    const offerId = isSubdomain ? '40' : '91';

    fetch(`${apiBaseUrl}/applications/log_offer_click`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        offer_id: offerId,
        application_id: thisApplication?.id
      })
    }).catch(err => console.error('Offer click log failed', err));

    window.open(
      'https://account.zolve.com/signup/email?utm_channel=affiliates&utm_source=affiliates_study_visa&utm_medium=email&utm_campaign=ST_US_CC_acquistion_17-06-25&utm_term=NA&utm_content=NA&utm_affiliate=Nomad_credit&referral_code=Nomad_credit',
      '_blank'
    );

    setShowToast(true);
  };

  return (
    <div className="offers-page">
      {isLoading ? (
        <div className="options offers-container offers-skeleton-container">
          <Container fluid className="section-block">
            <Row className="three-col-row">
              <Col xs={12} className="offers offers-list">
                <OfferSkeleton />
                <OfferSkeleton />
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <>
          <Modal
            title="Advertising Disclosures"
            open={advertisingDisclosuresVisible}
            onOk={(_) => {
              setAdvertisingDisclosuresVisible(false);
            }}
            onCancel={(_) => {
              setAdvertisingDisclosuresVisible(false);
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <div>
              Nomad Credit is an independent, advertising-supported comparison
              service. The loan options that appear on this site are from
              companies from which Nomad Credit receives compensation. This
              compensation may impact how and where products appear on this
              site, including, for example, the order in which they may appear
              within listing categories. Other factors, such as our own
              proprietary website rules and the likelihood of applicants' credit
              approval also impact how and where products appear on this site.
              Nomad Credit does not include the entire universe of available
              lenders, savings products or loan options available in the
              marketplace.
            </div>
          </Modal>
          <div className="options offers-container">
            <Container fluid className="section-block">
              <Row className="three-col-row">
                <Col xs={12}>
                  {/* <h1>Options</h1> */}
                  {offerData.length > 0 ? (
                    <div className="congratulations-banner mb-4">
                      <div className="text-container">
                        <h2>
                          Congratulations, {userData?.first_name || "User"}
                        </h2>
                        <input type="hidden" id="gtm-email" value={userData?.email || ""} />
                        <input type="hidden" id="gtm-phone" value={userData?.applications?.[0]?.phone_number || ""} />
                        <p className="description-text">
                          Based on your profile, here are some great options for
                          you!
                          <br className="br" />
                          Feel free to book a consultation for any questions.
                        </p>
                      </div>
                      <div className="image-container">
                        <Image
                          src={advisorImage}
                          alt="Professional Advisor"
                          className="advisor-image"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="not-found">
                      <p>
                        Based upon the information that you submitted, we did
                        not identify any options that fits your profile at this
                        time. We will reach out if this is a result of missing
                        information in your search. In the meantime, you are
                        eligible to search for other products. Please email any
                        questions that you may have to{" "}
                        <a href={"mailto:help@nomadcredit.com"}>
                          help@nomadcredit.com
                        </a>
                        .
                      </p>
                    </div>
                  )}
                  <div>
                    <p
                      style={{
                        marginTop: "10px",
                        textAlign: "center",
                        color: "blue",
                      }}
                    >
                      <a onClick={showAdvertisingDisclosures}>
                        Advertising Disclosures
                      </a>
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="three-col-row custom-half-padding">
                <Col xs={12} className="offers offers-list">
                  {offerData
                    ? offerData.map((x, i) => {
                      let { offer } = x;

                      return (
                        <div key={offer.uuid}>
                          {applicationType === "admissions" ? (
                            <Card
                              key={offer.uuid}
                              className="offer-card mb-3"
                              id={"offer_" + i}
                            >
                              <Card.Body className="offer-card-body">
                                <div>
                                  <Image
                                    style={{ height: "60px" }}
                                    src={offer.logo_img_url}
                                  ></Image>{" "}
                                  {offer.tracking_pixel_with_timestamp ? (
                                    <Image
                                      style={{ height: "1px" }}
                                      src={offer.tracking_pixel_with_timestamp}
                                      alt={"Advertisement"}
                                    ></Image>
                                  ) : (
                                    ""
                                  )}
                                  <h3>{offer.company_name}</h3>

                                  {offer.variable_rates ? (
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>Variable Rates</td>
                                          <td>Fixed Rates</td>
                                        </tr>
                                        <tr>
                                          <td
                                            dangerouslySetInnerHTML={{
                                              __html: offer.variable_rates,
                                            }}
                                          ></td>
                                          <td
                                            dangerouslySetInnerHTML={{
                                              __html: offer.fixed_rates,
                                            }}
                                          ></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  ) : (
                                    <br />
                                  )}
                                  {offer.short_disclosure ? (
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: offer.short_disclosure,
                                      }}
                                    ></p>
                                  ) : (
                                    ""
                                  )}
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: offer.description,
                                    }}
                                  />
                                  {offer.long_disclosure ? (
                                    <Accordion style={{ marginTop: "50px" }}>
                                      <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                          {offer.more_info_text
                                            ? offer.more_info_text
                                            : "Disclosure"}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          {offer.long_disclosure ? (
                                            <p
                                              dangerouslySetInnerHTML={{
                                                __html: offer.long_disclosure,
                                              }}
                                            ></p>
                                          ) : (
                                            ""
                                          )}
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="select-btn-container">
                                  <Button
                                    className=" select-btn"
                                    onClick={() => selectOffer(offer.url, i)}
                                  >
                                    Select
                                  </Button>
                                  <div style={{ float: "right", width: "max-content", marginTop: "15px" }}>
                                    <a href={offer.url}>
                                      Schedule Free Consultation
                                    </a>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          ) : (
                            <LoanOfferCard
                              offer={offer}
                              handleSelectOffer={(url, index, offer) =>
                                handleSelectOffer(url, index, x)
                              }
                              index={i}
                            />
                          )}
                          {applicationType &&
                            applicationType === "admissions" ? (
                            <div
                              id={"waiver_" + i}
                              className="offer-card-waiver offer-card hidden"
                            >
                              <h3>Admissions Service Sign Up</h3>
                              <p>
                                You are almost ready to begin our FREE Full
                                Admissions Service. All that remains is to
                                please confirm your details below and check
                                the box indicating that you have read our
                                waiver. We are excited to help you Begin Your
                                Journey!
                              </p>

                              <div className="landing-form nomad-form">
                                <Form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    const formData = new FormData(e.target),
                                      details = Object.fromEntries(
                                        formData.entries()
                                      );
                                    checkWaiver(details);
                                  }}
                                >
                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="text"
                                      id="alFName"
                                      name="application[first_name]"
                                      required
                                      defaultValue={
                                        thisApplication.first_name
                                      }
                                    />
                                    <Form.Label>First Name*</Form.Label>
                                  </Form.Group>

                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="text"
                                      id="alLName"
                                      name="application[last_name]"
                                      required
                                      defaultValue={thisApplication.last_name}
                                    />
                                    <Form.Label>Last Name*</Form.Label>
                                  </Form.Group>

                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="email"
                                      id="alEmail"
                                      name="application[email]"
                                      required
                                      defaultValue={thisApplication.email}
                                    />
                                    <Form.Label>Email*</Form.Label>
                                  </Form.Group>

                                  <Form.Group
                                    className="mb-3"
                                    controlId="phone"
                                  >
                                    <PhoneField
                                      name="application[phone_number]"
                                      required
                                      defaultValue={
                                        thisApplication.phone_number
                                      }
                                    />
                                    <Form.Label>Phone Number*</Form.Label>
                                  </Form.Group>

                                  <p>
                                    By checking this box you agree to the
                                    terms below.
                                  </p>

                                  <p>
                                    I acknowledge that by submitting this
                                    online form, I am requesting Nomad
                                    Credit’s admissions services. Nomad
                                    Credit’s services may include sending
                                    personal information and documents to
                                    colleges and universities.
                                  </p>

                                  <p>
                                    I confirm that all information and
                                    documents that I provide to Nomad Credit
                                    are true with nothing omitted or
                                    falsified.
                                  </p>

                                  <p>
                                    I acknowledge I am responsible for all
                                    tuition, fees and other costs related to
                                    the college(s), university(s) and/or
                                    program(s) of which I am applying.
                                  </p>
                                  <Form.Group className="mb-3">
                                    <Form.Check
                                      type={"checkbox"}
                                      id={`default-check`}
                                      required
                                    />
                                  </Form.Group>

                                  <Button
                                    variant="primary"
                                    size="lg"
                                    className="extra-pad"
                                    type="submit"
                                  >
                                    Submit
                                  </Button>
                                </Form>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        // <div key={i} className="offer-card">
                        //   <div className="offer-card-offer" id={"offer_" + i}>
                        //     <Image
                        //       style={{ height: "60px" }}
                        //       src={offer.logo_img_url}
                        //     ></Image>{" "}
                        //     {offer.tracking_pixel_with_timestamp ? (
                        //       <Image
                        //         style={{ height: "1px" }}
                        //         src={offer.tracking_pixel_with_timestamp}
                        //         alt={"Advertisement"}
                        //       ></Image>
                        //     ) : (
                        //       ""
                        //     )}
                        //     <h3>{offer.company_name}</h3>
                        //     {applicationType === "admissions" ? (
                        //       <>
                        //         <Button
                        //           className="offer-select"
                        //           onClick={() => selectOffer(offer.url, i)}
                        //         >
                        //           Select
                        //         </Button>
                        //         <div style={{ float: "right" }}>
                        //           <a href={offer.url}>
                        //             Schedule Free Consultation
                        //           </a>
                        //         </div>
                        //       </>
                        //     ) : (
                        //       <Button
                        //         className="offer-select"
                        //         onClick={() => selectOffer(offer.url, i, x)}
                        //       >
                        //         {" "}
                        //         Select
                        //       </Button>
                        //     )}
                        //     {offer.variable_rates ? (
                        //       <table>
                        //         <tbody>
                        //           <tr>
                        //             <td>Variable Rates</td>
                        //             <td>Fixed Rates</td>
                        //           </tr>
                        //           <tr>
                        //             <td
                        //               dangerouslySetInnerHTML={{
                        //                 __html: offer.variable_rates,
                        //               }}
                        //             ></td>
                        //             <td
                        //               dangerouslySetInnerHTML={{
                        //                 __html: offer.fixed_rates,
                        //               }}
                        //             ></td>
                        //           </tr>
                        //         </tbody>
                        //       </table>
                        //     ) : (
                        //       <br />
                        //     )}
                        //     {offer.short_disclosure ? (
                        //       <p
                        //         dangerouslySetInnerHTML={{
                        //           __html: offer.short_disclosure,
                        //         }}
                        //       ></p>
                        //     ) : (
                        //       ""
                        //     )}
                        //     <div
                        //       dangerouslySetInnerHTML={{
                        //         __html: offer.description,
                        //       }}
                        //     />
                        //     {offer.long_disclosure ? (
                        //       <Accordion style={{ marginTop: "50px" }}>
                        //         <Accordion.Item eventKey="0">
                        //           <Accordion.Header>
                        //             {offer.more_info_text
                        //               ? offer.more_info_text
                        //               : "Disclosure"}
                        //           </Accordion.Header>
                        //           <Accordion.Body>
                        //             {offer.long_disclosure ? (
                        //               <p
                        //                 dangerouslySetInnerHTML={{
                        //                   __html: offer.long_disclosure,
                        //                 }}
                        //               ></p>
                        //             ) : (
                        //               ""
                        //             )}
                        //           </Accordion.Body>
                        //         </Accordion.Item>
                        //       </Accordion>
                        //     ) : (
                        //       ""
                        //     )}
                        //   </div>
                        //   {applicationType && applicationType === "admissions" ? (
                        //     <div
                        //       id={"waiver_" + i}
                        //       className="offer-card-waiver hidden"
                        //     >
                        //       <h3>Admissions Service Sign Up</h3>
                        //       <p>
                        //         You are almost ready to begin our FREE Full
                        //         Admissions Service. All that remains is to please
                        //         confirm your details below and check the box
                        //         indicating that you have read our waiver. We are
                        //         excited to help you Begin Your Journey!
                        //       </p>

                        //       <div className="landing-form nomad-form">
                        //         <Form
                        //           onSubmit={(e) => {
                        //             e.preventDefault();
                        //             const formData = new FormData(e.target),
                        //               details = Object.fromEntries(
                        //                 formData.entries()
                        //               );
                        //             checkWaiver(details);
                        //           }}
                        //         >
                        //           <Form.Group className="mb-3">
                        //             <Form.Control
                        //               type="text"
                        //               id="alFName"
                        //               name="application[first_name]"
                        //               required
                        //               defaultValue={thisApplication.first_name}
                        //             />
                        //             <Form.Label>First Name*</Form.Label>
                        //           </Form.Group>

                        //           <Form.Group className="mb-3">
                        //             <Form.Control
                        //               type="text"
                        //               id="alLName"
                        //               name="application[last_name]"
                        //               required
                        //               defaultValue={thisApplication.last_name}
                        //             />
                        //             <Form.Label>Last Name*</Form.Label>
                        //           </Form.Group>

                        //           <Form.Group className="mb-3">
                        //             <Form.Control
                        //               type="email"
                        //               id="alEmail"
                        //               name="application[email]"
                        //               required
                        //               defaultValue={thisApplication.email}
                        //             />
                        //             <Form.Label>Email*</Form.Label>
                        //           </Form.Group>

                        //           <Form.Group className="mb-3" controlId="phone">
                        //             <PhoneField
                        //               name="application[phone_number]"
                        //               required
                        //               defaultValue={thisApplication.phone_number}
                        //             />
                        //             <Form.Label>Phone Number*</Form.Label>
                        //           </Form.Group>

                        //           <p>
                        //             By checking this box you agree to the terms
                        //             below.
                        //           </p>

                        //           <p>
                        //             I acknowledge that by submitting this online
                        //             form, I am requesting Nomad Credit’s
                        //             admissions services. Nomad Credit’s services
                        //             may include sending personal information and
                        //             documents to colleges and universities.
                        //           </p>

                        //           <p>
                        //             I confirm that all information and documents
                        //             that I provide to Nomad Credit are true with
                        //             nothing omitted or falsified.
                        //           </p>

                        //           <p>
                        //             I acknowledge I am responsible for all
                        //             tuition, fees and other costs related to the
                        //             college(s), university(s) and/or program(s) of
                        //             which I am applying.
                        //           </p>
                        //           <Form.Group className="mb-3">
                        //             <Form.Check
                        //               type={"checkbox"}
                        //               id={`default-check`}
                        //               required
                        //             />
                        //           </Form.Group>

                        //           <Button
                        //             variant="primary"
                        //             size="lg"
                        //             className="extra-pad"
                        //             type="submit"
                        //           >
                        //             Submit
                        //           </Button>
                        //         </Form>
                        //       </div>
                        //     </div>
                        //   ) : (
                        //     ""
                        //   )}
                        // </div>
                      );
                    })
                    : ""}
                </Col>
              </Row>
              <USCreditCards thisApplication={thisApplication} />


              {isUSSchool && (<>

                <Row className="three-col-row custom-half-padding more-credit-section"
                  style={{
                    backgroundImage: `url(${creditBackground})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >

                  <h1>Unlock More with Nomad Credit</h1>
                  {console.log('thisApplication before', thisApplication)}
                  {console.log('thisApplication after', thisApplication?.data?.school_country)}
                  <Col xs={12} className="offers offers-list">
                    {thisApplication && (
                      <Tabs
                        defaultActiveKey={defaultTab}
                        id="credit-refinance-tabs"
                        className="credit-refinance-tabs nav nav-tabs"
                      >
                        {isUSSchool && (
                          <Tab
                            eventKey="credit"
                            title="Credit Card"
                            className="credit-tab"
                          >
                            <Card className="p-4 shadow-sm bg-light">
                              <Row>
                                <Col md={3} className="text-center">
                                  <img src={zolveCards} alt="Credit Cards" className="img-fluid" />
                                </Col>
                                <Col md={9}>
                                  <Row>
                                    <Col md={8}>
                                      <h4>Arrive in the U.S. financially prepared</h4>
                                      <p>
                                        Apply for a U.S. Credit Card in minutes and start building your credit history from day one
                                      </p>
                                    </Col>
                                    <Col md={4}>
                                      <Button
                                        className="select-btn d-none d-md-block"
                                        onClick={handleApplyClick}
                                      >
                                        Apply Now <NorthEastIcon sx={{ fontSize: 20 }} />
                                      </Button>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={12}>
                                      <div className="pill-holder gap-3 mb-3">
                                        <div className="pill shadow-sm">
                                          <img src={npSsn} alt="No SSN" /> No SSN required to apply
                                        </div>
                                        <div className="pill shadow-sm">
                                          <img src={buildCredit} alt="Build Credit" /> Build U.S. credit history
                                        </div>
                                        <div className="pill shadow-sm">
                                          <img src={handMoney} alt="Credit Limit" /> Up to $15,000 credit limit
                                        </div>
                                      </div>
                                      <Button
                                        className="select-btn d-block d-md-none"
                                        onClick={handleApplyClick}
                                      >
                                        Apply Now <NorthEastIcon sx={{ fontSize: 20 }} />
                                      </Button>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                          </Tab>
                        )}

                        {/* <Tab
                          eventKey="refinance"
                          title="Refinancing"
                          className="refinance-tab"
                        >
                          <Card className="p-4 shadow-sm bg-light">
                            <Row>
                              <Col md={3} className="text-center">
                                <img
                                  src={indianGraduate}
                                  alt="Refinancing"
                                  className="img-fluid indian-graduate"
                                />
                              </Col>
                              <Col md={9} style={{ padding: 0 }}>
                                <h4>Launching Soon</h4>
                                <p>
                                  Refinance your education loan with lower rates and fewer worries
                                </p>
                                <div className="pill-holder gap-3 mb-3">
                                  <div className="pill shadow-sm">
                                    <img src={noFee} alt="No Fee" /> No fee required
                                  </div>
                                  <div className="pill shadow-sm">
                                    <img src={percentage} alt="Rates" /> Competitive Fixed Rates
                                  </div>
                                  <div className="pill shadow-sm">
                                    <img src={clock} alt="Flexible Terms" /> Flexible term options
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </Tab> */}
                      </Tabs>
                    )}
                  </Col>
                </Row>
              </>)}
            </Container>
          </div>

          {showToast && (
            <Snackbar
              open={showToast}
              autoHideDuration={3000}
              onClose={() => setShowToast(false)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              <Alert
                onClose={() => setShowToast(false)}
                severity="success"
                icon={false}
                sx={{
                  backgroundColor: "#e9f9ee",
                  color: "#344054",
                  borderRadius: "10px",
                  borderBottom: "4px solid #6CE9A6",
                  boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                  fontSize: "14px",
                  maxWidth: "360px",
                  width: "100%",
                  padding: "12px 16px",
                  alignItems: "flex-start",
                }}
              >
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#027A48", marginBottom: "4px" }}>
                    Success
                  </Typography>
                  <Typography variant="body2">
                    Redirecting to lender portal for further process
                  </Typography>
                </Box>
              </Alert>
            </Snackbar>
          )}
        </>
      )}
    </div>
  );
};

export default Offers;
